// Без SSR-разметки монтируем внутрь якоря: $mount заменяет узел, а по якорю CSS прячет легаси-шапку.
export function getSsrMountTarget(anchor: Element): Element {
    const ssrRoot = anchor.querySelector('[data-server-rendered="true"]');
    if (ssrRoot) {
        return ssrRoot;
    }

    const target = document.createElement('div');
    anchor.append(target);
    return target;
}
